import React from 'react'
import { useField } from 'formik'

import { NumberFieldProps, WithNumberFieldProps } from './interface'

export function withNumberField(Component: React.FC<NumberFieldProps>) {
  function WithNumberField({ name, ...props }: WithNumberFieldProps) {
    const [field, { touched, error }, { setValue }] = useField(name)

    function handleChange(event: React.ChangeEvent<HTMLInputElement>) {
      const { value } = event.target
      if (/[\d]+$/.test(value) || value === '') {
        setValue(value)
      }
    }

    const componentProps = {
      ...props,
      ...field,
      touched,
      error,
      onChange: handleChange,
    }

    return <Component {...componentProps} />
  }

  return WithNumberField
}
